import { getRequest, postRequest, URL, putRequest , deleteRequest} from "shared/utils";

import * as types from "./actionTypes";

export function getColumnSettings(tableName, userId, viewId = null) {
  const url = viewId 
    ? `${URL.settings}/ui/${tableName}/columns/visibility/user/${userId}?viewId=${viewId}`
    : `${URL.settings}/ui/${tableName}/columns/visibility/user/${userId}`;

  const request = getRequest(url);

  return {
    type: `${types.GET_COLUMN_SETTINGS}_${tableName}`,
    payload: request,
  };
}

export function setColumnVisibility(params) {
  const { data, tableName, userId, userEmail } = params;

  const url = `${URL.settings}/ui/${tableName}/columns/visibility/user/${userId}?savedBy=${userEmail}`;

  const request = postRequest(url, data);

  return {
    type: types.SET_COLUMN_VISIBILITY,
    payload: request,
  };
}

export function setColumnOrder(params) {
  const { data, tableName, userId, userEmail } = params;

  const url = `${URL.settings}/ui/${tableName}/columns/order/user/${userId}?savedBy=${userEmail}`;

  const request = postRequest(url, data);

  return {
    type: types.SET_COLUMN_VISIBILITY,
    payload: request,
  };
}

export function getFilterSettings(tableName, userEmailAddress, viewId = null) {
  const url = viewId 
    ? `${URL.settings}/ui/${tableName}/columns/filters?userEmailAddress=${userEmailAddress}&viewId=${viewId}`
    : `${URL.settings}/ui/${tableName}/columns/filters?userEmailAddress=${userEmailAddress}`;

  const request = getRequest(url);

  return {
    type: types.GET_FILTER_SETTINGS,
    payload: request,
  };
}

export function setFilterSettings(params) {
  const { settings, tableName, userEmailAddress } = params;

  const url = `${URL.settings}/ui/${tableName}/columns/filters?userEmailAddress=${userEmailAddress}&savedBy=${userEmailAddress}`;

  const request = postRequest(url, settings);

  return {
    type: types.SET_FILTER_SETTINGS,
    payload: request,
  };
}

export function updatePageSizeSetting(userId, tableName, pageSize, userEmail) {
  const url = `${URL.settings}/ui/pageSize?userId=${userId}&tableName=${tableName}&pageSize=${pageSize}&savedBy=${userEmail}`;

  const request = putRequest(url);

  return {
    type: types.UPDATE_PAGE_SIZE,
    payload: request,
  };
}

export function getPageSize(userId, tableName) {
  const url = `${URL.settings}/ui/pageSize?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_PAGE_SIZE,
    payload: request,
  };
}

export function setColumnVisibilityDrawer(params) {
  const { data, tableName, userId, userEmail } = params;

  const url = `${URL.settings}/ui/${tableName}/columns/drawerVisibility/user/${userId}?savedBy=${userEmail}`;

  const request = postRequest(url, data);

  return {
    type: types.SET_COLUMN_VISIBILITY_DRAWER,
    payload: request,
  };
}

export function getUserViewSettings(tableName, userId, clientId) {
  const url = `${URL.settings}/ui/${tableName}/user/views?userId=${userId}&clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_USER_VIEW_SETTINGS,
    payload: request,
  };
}

export function saveUserViewSetting(params) {
  const { tableName, userViewSetting } = params;

  const url = `${URL.settings}/ui/${tableName}/user/views`;

  const request = postRequest(url, userViewSetting);

  return {
    type: types.SAVE_USER_VIEW_SETTING,
    payload: request,
  };
}

export function updateUserViewSetting(params, isFilterSettingUpdate = false) {
  const { tableName, userViewSetting } = params;

  const url = `${URL.settings}/ui/${tableName}/user/views?isFilterSettingUpdate=${isFilterSettingUpdate}`;

  const request = putRequest(url, userViewSetting);

  return {
    type: types.UPDATE_USER_VIEW_SETTING,
    payload: request,
  };
}

export function deleteUserViewSetting(id, modifiedBy) {
  const url = `${URL.settings}/ui/user/view?viewId=${id}&modifiedBy=${modifiedBy}`;

  const request = deleteRequest(url);

  return {
    type: types.DELETE_USER_VIEW_SETTING,
    payload: request,
  };
}

export function setViewAsDefault(params) {
  const { tableName, userViewPreference } = params;

  const url = `${URL.settings}/ui/${tableName}/user/defaultView`;

  const request = putRequest(url, userViewPreference);

  return {
    type: types.SET_USER_DEFAULT_SETTING,
    payload: request,
  };
}

export function getNoticeDate(userId,tableName) {
  const url = `${URL.settings}/ui/noticeDate?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_NOTICE_DATE,
    payload: request,
  };
}

export function getDrawerColumnSettings(tableName, userId) {
  const url = `${URL.settings}/ui/drawer/visibility?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: `${types.GET_COLUMN_SETTINGS}_${tableName}`,
    payload: request,
  };
}